import React from "react";
import Label from "./Label";
import { inputClassName, inputErrorClassName } from "./classNames";
import ErrorIcon from "../Icons/ErrorIcon";

const SelectInput = ({ id, label, options = [], register, errors }) => {
  return (
    <div>
      <Label htmlFor={id} label={label} />
      <select
        id={id}
        // className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${
        //   (errors && errors[id]) ? "border-red-300" : "border-gray-300"
        // }`}
        className={inputClassName}
        {...register}
      >
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.disabled}
            selected={option.selected}
          >
            {option.label}
          </option>
        ))}
      </select>
      {errors && errors[id] && (
        <div className="text-red-500 text-sm mt-1 flex items-center">
          <ErrorIcon />
          <span>{errors[id].message}</span>
        </div>
      )}
    </div>
  );
};

export default SelectInput;
